export const getSaleType = (num, stock = null) => {
  switch (num) {
    case 1:
      return !stock && stock !== 0 ? "BUY" : stock === 0 ? "SOLD OUT" : "ADD TO CART"

    case 2:
      return "門市專售"

    case 4:
      return "即將開賣"

    case 8:
      return stock === 0 ? "貨到通知" : "申請租賃"

    case 16:
      return stock === 0 ? "SOLD OUT" : "ADD TO CART"

    case 32:
      return "即將開賣"

    case 64:
      return "暫停銷售"

    case 128:
      return stock === 0 ? "貨到通知" : "申請租賃"

    default:
      return "即將開賣"
  }
}

// get sell state by sell
export const getSellState = (currentSell) => {
  // 0x01: OS_加入購物車
  // 0x02: OS_門市專售
  // 0x04: OS_即將開賣
  // 0x08: OS_申請租賃 (Go Charger)
  // 0x016: OF_加到購物車
  // 0x032: OF_即將開賣
  // 0x064: OF_暫停銷售
  // 0x128: OF_申請租賃 (Go Charger)
  let sell

  switch (currentSell) {
    case 0:
      sell = [0, 0]
      break

    case 1:
      sell = [0, 1]
      break
    case 2:
      sell = [0, 2]
      break
    case 4:
      sell = [0, 4]
      break
    case 8:
      sell = [0, 8]
      break

    case 16:
      sell = [16, 0]
      break
    case 32:
      sell = [32, 0]
      break
    case 64:
      sell = [64, 0]
      break
    case 128:
      sell = [128, 0]
      break

    case 17:
      sell = [16, 1]
      break
    case 33:
      sell = [32, 1]
      break
    case 65:
      sell = [64, 1]
      break
    case 129:
      sell = [128, 1]
      break

    case 18:
      sell = [16, 2]
      break
    case 34:
      sell = [32, 2]
      break
    case 66:
      sell = [64, 2]
      break
    case 130:
      sell = [128, 2]
      break

    case 20:
      sell = [16, 4]
      break
    case 36:
      sell = [32, 4]
      break
    case 68:
      sell = [64, 4]
      break
    case 132:
      sell = [128, 4]
      break

    case 24:
      sell = [16, 8]
      break
    case 40:
      sell = [32, 8]
      break
    case 72:
      sell = [64, 8]
      break
    case 136:
      sell = [128, 8]
      break

    default:
      sell = [0, 0]
      break
  }

  return sell[0]
}

export const calcAge = (by, bm, bd) => {
  const today = new Date()
  let age = today.getFullYear() - by

  if (today.getMonth() < bm - 1) {
    age--
  }
  if (bm - 1 === today.getMonth() && today.getDate() < bd) {
    age--
  }

  return age
}
